import moment from 'moment';
import { environment } from '../../../../environments/environment';
import { NotificationCampaignResult } from '../api-results/notification-campaign.api-result';
import {
  NotificationTemplate,
  NotificationCampaignTargetedActiveUsers,
} from '../enums/notification.enums';
import { SubscriptionTier } from '../enums/subscription.enums';
import { NotificationCampaignFormValue } from '../payloads/notification-campaign.payload';
import { Writer } from './writer.entity';

export class NotificationCampaign {
  id: string;
  templateName: NotificationTemplate;
  title: string;
  message: string;
  path: string;
  subscriptionTierTarget: SubscriptionTier[];
  targetedActiveUsers: NotificationCampaignTargetedActiveUsers;
  isMailSupported: boolean;
  isPushSupported: boolean;
  isWebsiteSupported: boolean;
  publishAt: Date;
  author: Writer;
  createdAt: Date;
  isProcessing: boolean;
  isProcessed: boolean;
  externalEmailCampaignId: string;
  totalUsersTargetedEmail: number;
  totalUsersTargetedPush: number;
  totalUsersTargetedWebsite: number;

  constructor(result: NotificationCampaignResult) {
    this.id = result.id;
    this.templateName = result.templateName;
    this.title = result.title;
    this.message = result.message;
    this.path = result.path;
    this.subscriptionTierTarget = result.subscriptionTierTarget;
    this.targetedActiveUsers = result.targetedActiveUsers;
    this.isMailSupported = result.isMailSupported;
    this.isPushSupported = result.isPushSupported;
    this.isWebsiteSupported = result.isWebsiteSupported;

    if (result.publishAt) {
      this.publishAt = moment(result.publishAt).toDate();
    }
    if (result.author) {
      this.author = new Writer(result.author);
    }
    if (result.createdAt) {
      this.createdAt = moment(result.createdAt).toDate();
    }
    this.isProcessing = result.isProcessing;
    this.isProcessed = result.isProcessed;
    this.externalEmailCampaignId = result.externalEmailCampaignId;
    this.totalUsersTargetedEmail = result.totalUsersTargetedEmail;
    this.totalUsersTargetedPush = result.totalUsersTargetedPush;
    this.totalUsersTargetedWebsite = result.totalUsersTargetedWebsite;
  }

  toFormValue(): NotificationCampaignFormValue {
    return {
      templateName: this.templateName,
      title: this.title,
      message: this.message,
      path: this.path,
      subscriptionTierTarget: this.subscriptionTierTarget,
      targetedActiveUsers: this.targetedActiveUsers,
      isMailSupported: this.isMailSupported,
      isPushSupported: this.isPushSupported,
      isWebsiteSupported: this.isWebsiteSupported,
      publishAt: this.publishAt,
    };
  }
}

export class NotificationCampaignStatistics {
  totalUsersDeliveredEmail: number;
  totalUsersFailedEmail: number;
  totalUsersOpenedEmail: number;
  totalUsersTargetedEmail: number;
  totalUsersTargetedPush: number;
  totalUsersTargetedWebsite: number;

  constructor(result: any) {
    this.totalUsersDeliveredEmail = result.totalUsersDeliveredEmail;
    this.totalUsersFailedEmail = result.totalUsersFailedEmail;
    this.totalUsersOpenedEmail = result.totalUsersOpenedEmail;
    this.totalUsersTargetedEmail = result.totalUsersTargetedEmail;
    this.totalUsersTargetedPush = result.totalUsersTargetedPush;
    this.totalUsersTargetedWebsite = result.totalUsersTargetedWebsite;
  }
}
